import React from 'react';
import './CardMetricV1.scss';

interface CardMetricV1Props {
  key?: string | number; // key is actually not needed here since it's not used as a prop
  header?: [string, string] | null;
  data?: [string | number, string | number] | null;
  title?: string;
  label: string,
  selectedCardMetric: string | null,
  setSelectedCardMetric: (param: string) => void
}

const CardMetricV1: React.FC<CardMetricV1Props> = ({ 
  header, 
  data, 
  title,
  label = '',
  selectedCardMetric,
  setSelectedCardMetric = () => {},

 }) => {

  return (
    <div className={label === selectedCardMetric ? 'card-metric-V1_active' : 'card-metric-V1'}
    onClick={() => setSelectedCardMetric(label)}
    >
      <h3 className='card-metric-V1__title-card'>{title || '-'}</h3>

      <div className='card-metric-V1__content'>
        {header?.length ?
          header?.map((item, ind) => {
            return <p className='card-metric-V1__text-header'>
              {item} - <span>{data?.[ind] ?? '-'}</span>
            </p>
          })
          :
          [...Array(4)?.map((item, ind) => {
            return <p className='card-discount__text-header'>-</p>
          })]
        }
      </div>
    </div>
  );
};

export { CardMetricV1 };